import { render, staticRenderFns } from "./frienddialog.vue?vue&type=template&id=53e587c4&scoped=true"
import script from "./frienddialog.vue?vue&type=script&lang=js"
export * from "./frienddialog.vue?vue&type=script&lang=js"
import style0 from "./frienddialog.vue?vue&type=style&index=0&id=53e587c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e587c4",
  null
  
)

export default component.exports